import { default as selectCpdCategorysCpdConfiguration } from './selectCpdCategorys';
import { default as selectPlanConfiguration } from './selectPlan';

export const configurations = [
  selectPlanConfiguration,
  selectCpdCategorysCpdConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/global/configurations/index.js